import { render } from "./ArenaScheduleToday.vue?vue&type=template&id=04e62bd3&scoped=true"
import script from "./ArenaScheduleToday.vue?vue&type=script&lang=js"
export * from "./ArenaScheduleToday.vue?vue&type=script&lang=js"

import "./ArenaScheduleToday.vue?vue&type=style&index=0&id=04e62bd3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04e62bd3"
/* hot reload */
if (module.hot) {
  script.__hmrId = "04e62bd3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04e62bd3', script)) {
    api.reload('04e62bd3', script)
  }
  
  module.hot.accept("./ArenaScheduleToday.vue?vue&type=template&id=04e62bd3&scoped=true", () => {
    api.rerender('04e62bd3', render)
  })

}

script.__file = "src/components/ArenaScheduleToday.vue"

export default script